import { Navigate, Outlet, useOutletContext } from 'react-router-dom';

import Spinner from '@/components/shared/spinner';
import useAuth from '@/hooks/use-auth';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const context = useOutletContext();

  if (isLoading) {
    return <Spinner />;
  }

  return isAuthenticated ? <Outlet context={context} /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
